"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
;
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        noBorder: {
            border: 0,
        },
    });
});
var Loading = function (props) {
    var classes = useStyles(props);
    var _a = react_1.default.useState(false), showLoading = _a[0], setShowLoading = _a[1];
    react_1.default.useEffect(function () {
        var interval = setTimeout(function () { setShowLoading(true); }, 500);
        var longTime = props.onLongLoad ? setTimeout(function () { props.onLongLoad(); }, props.delay) : undefined;
        return function cleanup() {
            clearInterval(interval);
            if (longTime) {
                clearInterval(longTime);
            }
        };
    });
    if (showLoading) {
        return (react_1.default.createElement(Card_1.default, { elevation: 0, className: props.noBorder ? classes.noBorder : null },
            react_1.default.createElement(CardContent_1.default, null,
                react_1.default.createElement(Grid_1.default, { container: true, direction: "column", justifyContent: "center", alignItems: "center" },
                    react_1.default.createElement(CircularProgress_1.default, { color: "primary" }),
                    react_1.default.createElement(Typography_1.default, { variant: "h2", style: { marginTop: 16 } }, props.title)))));
    }
    else {
        return null;
    }
};
exports.Loading = Loading;
exports.Loading.defaultProps = {
    delay: 30000,
};
